import Cookies from "js-cookie"

import Hook from "../utils/hook"

export default Hook(`NativeApp`, {
  targets: [`closeButton`, `openLink`],
  values: {
    active: Boolean,
    name: String,
    iosUrl: String,
    androidUrl: String,
    customProtocol: String,
  },
  actions: [
    {
      name: `close`,
      target: `closeButton`,
      type: `click`,
    },
    {
      name: `open`,
      target: `openLink`,
      type: `click`,
    },
  ],

  cookieName: ``,
  isIos: /(iPhone|iPad|iPod)/.test(window.navigator.userAgent),
  isAndroid: /(Android)/.test(window.navigator.userAgent),

  mounted() {
    this.cookieName = `native-app-${this.nameValue}`

    if (
      this.openLinkTarget &&
      ((this.isIos && this.iosUrlValue) ||
        (this.isAndroid && this.androidUrlValue)) &&
      !Cookies.get(this.cookieName)
    ) {
      this.attributeSet(
        `href`,
        this.isIos ? this.iosUrlValue : this.androidUrlValue,
        this.openLinkTarget
      )

      this.activeValue = true
    }
  },

  closeAction() {
    this.activeValue = false
    if (this.cookieName) Cookies.set(this.cookieName, true, { expires: 30 })
  },

  openAction(e) {
    if (this.customProtocolValue) {
      e.preventDefault()
      window.location.href = this.customProtocolValue

      if (this.isIos)
        window.setTimeout(
          () => (window.location.href = this.openLinkTarget.href),
          1
        )
      else
        window.setTimeout(
          () => window.open(this.openLinkTarget.href, `_blank`, `noopener`),
          200
        )
    }
  },
})
